import React, { useContext, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { infoSource, requestAxios } from "../../util/util";
import AppContext from "../../Context/AppContext";
import { Chart as ChartJS } from "chart.js/auto";
import { Pie,PolarArea } from "react-chartjs-2";
import "./MiActividad.css";

const MiPerfil = () => {
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const history = useHistory();
  const infoUs = checkUserSession();
  const colorArr = [
    "rgb(114, 57, 234)",
    "rgb(80, 205, 137)",
    "rgb(255, 199, 0)",
    "rgb(241, 65, 108)",
    "rgb(0, 11, 172)",
    "rgb(1, 190, 248)",
  ];
  const [show, setShow] = useState(false);
  const [acreditadosPedientes, setAcreditadosPedientes] = useState([]);
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });
  const [dataMesAnterior, setDataMesAnterior] = useState({
    labels: [],
    datasets: [],
  });
  const [cantidadesGestionadas, setCantidadesGestionadas] = useState({
    Asignados: 0,
    Gestionados: 0,
    Faltan: 0,
  });
  const [dataGestionAcreditado, setDatGestionAcreditado] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    changeLoading(true);
    const infoUs = checkUserSession();
    const { error, data } = await requestAxios({
      url: `Acreditados/getRegistrosPasadoMes`,
      method: "get",
      token: infoUs.bearer_token,
      data: {},
    });
    if (error === "") {
      setData({
        labels: data.countTipoGestion.map((item) => item.TipoGestionNombre),
        datasets: [
          {
            label: "Mi Actividad",
            data: data.countTipoGestion.map((item, i) => item.Cantidad),
            fill: true,
            backgroundColor: data.countTipoGestion.map((item, i) =>
              colorArr[i].replace(")", ",0.2)")
            ),
            borderColor: data.countTipoGestion.map((item, i) => colorArr[i]),
          },
        ],
      });
      setDataMesAnterior({
        labels: data.countTipoGestionPasado.map(
          (item) => item.TipoGestionNombre
        ),
        datasets: [
          {
            label: "Mi Actividad",
            data: data.countTipoGestionPasado.map((item, i) => item.Cantidad),
            fill: true,
            backgroundColor: data.countTipoGestionPasado.map((item, i) =>
              colorArr[i].replace(")", ",0.2)")
            ),
            borderColor: data.countTipoGestionPasado.map(
              (item, i) => colorArr[i]
            ),
          },
        ],
      });
      var qtyAcreditadosPendientes = data.AcreditadosPendientes.filter(
        (item) => item.GestionMensual == null
      ).length;
      var qtyAcreditadosCorrecto = data.AcreditadosPendientes.filter(
        (item) => item.GestionMensual != null
      ).length;
      setAcreditadosPedientes(
        data.AcreditadosPendientes.filter((item) => item.GestionMensual == null)
      );
      setDatGestionAcreditado({
        labels: ["Gestionados", "Faltan por Gestionar:"],
        datasets: [
          {
            label: "Gestion de acreditados",
            data: [
              round(
                (qtyAcreditadosCorrecto /
                  data.AcreditadosPendientes.length) *
                  100
              ),
              round(
                (qtyAcreditadosPendientes /
                  data.AcreditadosPendientes.length) *
                  100
              ),
            ],
            fill: true,
            backgroundColor: ["rgb(80, 205, 137,.2)", "rgb(241, 65, 108,.2)"],
            borderColor: ["rgb(80, 205, 137)", "rgb(241, 65, 108)"],
          },
        ],
      });
      setCantidadesGestionadas({
        Asignados: data.AcreditadosPendientes.length,
        Gestionados: qtyAcreditadosCorrecto,
        Faltan: qtyAcreditadosPendientes,
      });
    }
    changeLoading(false);
  }
  function round(num) {
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  }

  console.log(round(1.005));
  return (
    <section className="MiActividad__Container">
      <h1>Gestión de acreditados</h1>
      <div className="GestionAcreditadosChart__Container">
        <div className="MiActividadChart__item">
          <h3>Mis acreditados</h3>
          <Pie
            data={dataGestionAcreditado}
            options={{ maintainAspectRatio: false }}
          />
        </div>
        <div className="CantidadCasos">
          Casos asignados: {cantidadesGestionadas.Asignados}
          <br />
          Gestionados: {cantidadesGestionadas.Gestionados} {"-->"} %
          {round(
            (cantidadesGestionadas.Gestionados /
              cantidadesGestionadas.Asignados) *
              100
          )}
          <br />
          Faltan por Gestionar: {cantidadesGestionadas.Faltan} {"-->"} %
          {round(
            (cantidadesGestionadas.Faltan / cantidadesGestionadas.Asignados) *
              100
          )}
          <br />
          <button
            className="btnGestionesFaltantes"
            onClick={() => setShow(true)}
          >
            Ver Gestiones Faltantes
          </button>
        </div>
      </div>
      <br />
      <br />
      <br />
      <h1>Mi Actividad</h1>
      <div className="MiActividadChart__Container">
        <div className="MiActividadChart__item">
          <h3>Mi gestiones del mes</h3>
          <PolarArea data={data} options={{ maintainAspectRatio: false }} />
        </div>
        <div className="MiActividadChart__item">
          <h3>Mi gestiones del mes pasado</h3>
          <PolarArea
            data={dataMesAnterior}
            options={{ maintainAspectRatio: false }}
          />
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Acreditados sin gestion en el mes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="AcreditadosPedientes__container">
            {acreditadosPedientes.map((item, i) => {
              debugger;
              return (
                <div className="AcreditadosPedientes__ItemContainer">
                  <a
                    className="lblAcreditadoDetalle"
                    href={`./AcreditadosDetalle/${item.AcreditadoId}`}
                  >
                    (Exp. {item.AcreditadoId}) {item.NombreAcreditado}
                  </a>
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default MiPerfil;
